export const FULLFILL_CLIENTS = 'FULLFILL_CLIENTS'
export const FULLFILL_CLIENT = 'FULLFILL_CLIENT'
export const DELETE_CLIENT = 'DELETE_CLIENT'
export const FULLFILL_SPECIALIST = 'FULLFILL_SPECIALIST'
export const ADD_SPECIALIST = 'ADD_SPECIALIST'
export const DELETE_CLIENT_SPECIALIST = 'DELETE_CLIENT_SPECIALIST'
export const CHANGE_PROGRESS = 'CHANGE_PROGRESS'
export const SET_VALIDATION_ERRORS = 'SET_VALIDATION_ERRORS'
export const RESET_VALIDATION_ERRORS_BY_FIELD = 'RESET_VALIDATION_ERRORS_BY_FIELD'